import http from '../helpers/http';

const DailySchedule = (token: string) => {
  const headers = { 'x-access-token': token };

  return {
    getByDate: async (schoolId: string, date: string) => {
      const result = await http.get(`/school/${schoolId}/daily-schedule?date=${date}`, { headers });
      return result.data;
    },
    getWeek: async (schoolId: string, weekStart: string) => {
      const result = await http.get(`/school/${schoolId}/daily-schedule/week?weekStart=${weekStart}`, { headers });
      return result.data;
    },
    copyPreviousWeek: async (schoolId: string, body: { weekStart: string }) => {
      const result = await http.post(`/school/${schoolId}/weekly-schedule/copy-previous`, body, { headers });
      return result.data;
    },
    listEmployees: async (schoolId: string) => {
      const result = await http.get(`/school/${schoolId}/daily-schedule/employees`, { headers });
      return result.data;
    },
    create: async (schoolId: string, body: { date: string }) => {
      const result = await http.post(`/school/${schoolId}/daily-schedule`, body, { headers });
      return result.data;
    },
    copyPrevious: async (schoolId: string, body: { targetDate: string }) => {
      const result = await http.post(`/school/${schoolId}/daily-schedule/copy-previous`, body, { headers });
      return result.data;
    },
    send: async (scheduleId: string) => {
      const result = await http.post(`/daily-schedule/${scheduleId}/send`, {}, { headers });
      return result.data;
    },
    validate: async (scheduleId: string) => {
      const result = await http.get(`/daily-schedule/${scheduleId}/validate`, { headers });
      return result.data;
    },
    clear: async (scheduleId: string) => {
      const result = await http.post(`/daily-schedule/${scheduleId}/clear`, {}, { headers });
      return result.data;
    },
    addRoom: async (scheduleId: string, body: object) => {
      const result = await http.post(`/daily-schedule/${scheduleId}/rooms`, body, { headers });
      return result.data;
    },
    updateRoom: async (scheduleId: string, roomId: string, body: object) => {
      const result = await http.put(`/daily-schedule/${scheduleId}/rooms/${roomId}`, body, { headers });
      return result.data;
    },
    removeRoom: async (scheduleId: string, roomId: string) => {
      const result = await http.delete(`/daily-schedule/${scheduleId}/rooms/${roomId}`, { headers });
      return result.data;
    },
    addEntry: async (scheduleId: string, roomId: string, body: object) => {
      const result = await http.post(`/daily-schedule/${scheduleId}/rooms/${roomId}/entries`, body, { headers });
      return result.data;
    },
    updateEntry: async (scheduleId: string, entryId: string, body: object) => {
      const result = await http.put(`/daily-schedule/${scheduleId}/entries/${entryId}`, body, { headers });
      return result.data;
    },
    removeEntry: async (scheduleId: string, entryId: string) => {
      const result = await http.delete(`/daily-schedule/${scheduleId}/entries/${entryId}`, { headers });
      return result.data;
    },
    addAnnouncement: async (scheduleId: string, body: { text: string }) => {
      const result = await http.post(`/daily-schedule/${scheduleId}/announcements`, body, { headers });
      return result.data;
    },
    removeAnnouncement: async (scheduleId: string, announcementId: string) => {
      const result = await http.delete(`/daily-schedule/${scheduleId}/announcements/${announcementId}`, { headers });
      return result.data;
    },
    addFloater: async (scheduleId: string, body: object) => {
      const result = await http.post(`/daily-schedule/${scheduleId}/floaters`, body, { headers });
      return result.data;
    },
    updateFloater: async (scheduleId: string, floaterId: string, body: object) => {
      const result = await http.put(`/daily-schedule/${scheduleId}/floaters/${floaterId}`, body, { headers });
      return result.data;
    },
    removeFloater: async (scheduleId: string, floaterId: string) => {
      const result = await http.delete(`/daily-schedule/${scheduleId}/floaters/${floaterId}`, { headers });
      return result.data;
    },
    addFloaterBlock: async (scheduleId: string, floaterId: string, body: object) => {
      const result = await http.post(`/daily-schedule/${scheduleId}/floaters/${floaterId}/blocks`, body, { headers });
      return result.data;
    },
    updateFloaterBlock: async (scheduleId: string, floaterId: string, blockId: string, body: object) => {
      const result = await http.put(`/daily-schedule/${scheduleId}/floaters/${floaterId}/blocks/${blockId}`, body, {
        headers,
      });
      return result.data;
    },
    removeFloaterBlock: async (scheduleId: string, floaterId: string, blockId: string) => {
      const result = await http.delete(`/daily-schedule/${scheduleId}/floaters/${floaterId}/blocks/${blockId}`, {
        headers,
      });
      return result.data;
    },
  };
};

export default DailySchedule;
